module.exports = {"title":"Error 404","layout":"error","path":"/404.html","body":"<p>Nothing to see here, either you’re accessing a wrong url or this page doesn’t exist anymore.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./404.md
// module id = 545
// module chunks = 0